import cloneDeep from 'lodash/cloneDeep';
import * as allTypes from '@/store/mutation-type';
import transformer from '@/services/ligneCommande/ligneDcfServerTableDataTransformer';
import getAll from '@/api/ligneCommandeView';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import genererCritereLignesDevis from '@/services/bodac/devis/genererCritereLignesDevis';
import * as types from '@/store/modules/bodac/factureParLigne-mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    lastPayload: {},
    // permet de recuperer les criteres depuis notre service et de les cloné
    criteresRecherche: cloneDeep(genererCritereLignesDevis()),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_TOTAL](state, count) {
    state.totalCount = count;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.RESET_CRITERE](state) {
    state.criteresRecherche = cloneDeep(genererCritereLignesDevis());
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadLignesDevis({ commit }, search) {
    const dataToSend = transformer(cloneDeep(search));
    commit(types.SET_LAST_PAYLOAD, dataToSend);
    const data = (await getAll(dataToSend)).data.result;
    // Pour chaque ligne dans data.items
    data.items.forEach((ligne) => {
      // Si la ligne commercialID est renseigné tu as forcement un nom et prenom
      if (ligne.commercialId) {
        // Alors on cible la colonne nomComercial ()
        ligne.nomCommercial = nomPrenomGetter({
          nom: ligne.commercialNom,
          prenom: ligne.commercialPrenom,
        });
      }
    });
    commit(types.SET_ITEMS, data.items);
    commit(types.SET_TOTAL, data.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
